export default __webpack_public_path__ + "static/media/exit.5ac05d31.png";